"use strict";
const referrer = document.referrer;
const entries = performance.getEntriesByType("navigation");
const country_array = ["Ethiopia", "Kenya", "Rwanda", "Colombia", "El Salvador", "Bolivia", "Ecuador", "Cuba", "Uganda", "Yemen", "India", "Sri Lanka", "Myanmar", "Thailand", "Vietnam", "Indonesia", "East Timor", "Papua New Guinea", "Australia", "China", "Taiwan", "Okinawa", "Venezuela"];
let isBack = false;
let device = "pc";
entries.forEach((entry) => {
  if (entry.type === "back_forward") {
    isBack = true;
  }
});

const mediaQueryList = window.matchMedia("(max-width:599px)");
const listener = (event) => {
  //
  if (event.matches) {
    device = "sp";
  } else {
    device = "pc";
  }
  resize();
};
mediaQueryList.addEventListener("change", listener);
listener(mediaQueryList);

document.addEventListener("DOMContentLoaded", () => {
  // console.log("referrer:" + referrer);

  const assetsPath = "/cdn/shop/t/2/assets/";

  const body = document.body;
  const jsCols = document.querySelectorAll(".js-col");
  const jsMapBtn = document.querySelector(".js-map-btn");
  const jsMainLayout = document.querySelector(".js-main-layout");
  const jsHeaderGrid = document.querySelector(".js-header-grid");
  const jsLines = document.querySelector(".js-lines");
  const jsLogo1Figure = document.querySelector(".js-logo-1-figure");
  const jsLogo2Figure = document.querySelector(".js-logo-2-figure");
  const jsLogo = document.querySelector(".js-logo");
  const jsLogo_2 = document.querySelector(".js-logo--2");
  const jsLogo1 = document.querySelector(".js-logo-1");
  const jsLogo2 = document.querySelector(".js-logo-2");
  const jsLogo3 = document.querySelector(".js-logo-3");
  const jsLogo4 = document.querySelector(".js-logo-4");
  const jsLogo5 = document.querySelector(".js-logo-5");
  const jsLogo6 = document.querySelector(".js-logo-6");
  const jsLogo7 = document.querySelector(".js-logo-7");
  const jsLogo8 = document.querySelector(".js-logo-8");
  const jsLogo9 = document.querySelector(".js-logo-9");
  const jsLogo10 = document.querySelector(".js-logo-10");
  const jsLogo11 = document.querySelector(".js-logo-11");
  const jsLogo12 = document.querySelector(".js-logo-12");
  const jsLogo13 = document.querySelector(".js-logo-13");

  const jsColAbouts = document.querySelectorAll(".js-col-about");

  const jsMap = document.querySelector(".js-map");
  // const markers = document.querySelectorAll(".marker");
  const markers = document.querySelectorAll('circle[fill="#427AB9"]');
  const markerLists = document.querySelectorAll(".marker-list");

  const jsMouseoverImgs = document.querySelectorAll(".js-mouseover-img");
  const jsModal = document.querySelector(".js-modal");

  const jsModalOpen = document.querySelectorAll(".js-modal-open");

  const jsProductsNavItems = document.querySelectorAll(".js-products-nav__item");

  const jsProductNames = document.querySelectorAll(".js-product-name");

  const body_type = body.dataset.type;

  const a = document.querySelectorAll("a[href]");
  const lang = body.dataset.lang;

  const jsNewsLetterModal = document.querySelector(".js-news_letter-modal");

  if (a) {
    a.forEach((a) => {
      let href = a.getAttribute("href");
      if (href.charAt(0) == "/") {
        if (lang != "ja") {
          if (href == "/") {
            // console.log(href);
            if (a.dataset.locale != "en") {
              a.setAttribute("href", "/en/");
            }
          } else if (a.getAttribute("href").substring(0, 4) != "/en/") {
            // console.log(href);
            a.setAttribute("href", "/en" + href);
          }
        }
      }
    });
  }

  if (body_type == "product") {
    jsMainLayout.classList.add("menu2");
    jsHeaderGrid.classList.add("menu2");

    // 対象となるノード（親要素）
    const targetNode = document.querySelector("product-info");

    // console.log(targetNode);

    // 監視のオプション
    const config = { childList: true, subtree: true };

    // コールバック関数
    const callback = function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          // 例えば「.product-recommendations」が表示されたら発火
          if (document.querySelector("product-recommendations")) {
            // console.log("📦 Related items appeared!");

            const html = document.querySelector("product-recommendations").innerHTML;

            // ここに発火させたい処理を書く

            if (html.length > 20) {
              myCustomFunction();

              // 監視終了（1回だけ発火させる場合）
              observer.disconnect();
            }
            break;
          }
        }
      }
    };

    // オブザーバーの作成と開始
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);

    function myCustomFunction() {
      // ここに任意の処理を書く（例：アニメーション、トラッキングなど）
      // console.log("🎯 Custom function fired after related items loaded!");
    }
  }

  if (device == "sp") {
    if (document.querySelector(".rsr-map-wrap")) {
      document.querySelector(".rsr-map-wrap").scrollLeft = 500;
    }
  }

  jsMainLayout.dataset.type = body_type;
  jsHeaderGrid.dataset.type = body_type;

  if (body.classList.contains("index") && referrer === "" && !isBack) {
    jsLines.style.display = "flex";
    jsLogo.style.display = "block";
    jsLogo_2.style.display = "none";
    if (jsMainLayout) {
      let tl1 = gsap.timeline();
      let tl2 = gsap.timeline();

      tl1
        .fromTo(
          jsLines,
          {
            opacity: 0,
            scaleY: 0,
          },
          { opacity: 1, scaleY: 1, duration: 1, ease: "power4.inOut" }
        )
        .to(jsLines, {
          opacity: 0,
          scaleY: 1,
          duration: 1,
          delay: 5,
          ease: "power4.inOut",
          onComplete: function () {
            jsLines.style.display = "none";
          },
        });

      tl2
        .fromTo(
          jsMainLayout,
          {
            opacity: 0,
          },
          {
            opacity: 0.2,

            duration: 1,
            delay: 1,
            ease: "power4.inOut",
            onComplete: intro2,
          }
        )
        .to(
          jsMainLayout,

          {
            opacity: 1,
            duration: 1,
            delay: 5,
            ease: "power4.inOut",
          }
        );
    }

    function intro2() {
      // console.log("intro2");
      if (jsLogo1) {
        // alert("jsLogo1");
        if (device == "pc") {
          let left_arr = [0, 11.176, 22.399, 36.448, 42.187, 47.734, 54.045, 60.554, 72.264, 77.545, 83.616, 89.844, 96.631];
          let left_arr2 = [0, 47.7, 95.6];
          let tl = gsap.timeline();

          for (let i = 1; i <= 13; i++) {
            gsap.set(eval("jsLogo" + i), { left: left_arr[i - 1] + "%" });
          }
          for (let i = 1; i <= 3; i++) {
            gsap.to(eval("jsLogo" + i), {
              left: left_arr2[i - 1] + "%",
              duration: 1,
              ease: "power4.inOut",
              delay: 2,
            });
          }
          for (let i = 4; i <= 13; i++) {
            gsap.to(eval("jsLogo" + i), {
              opacity: 0,

              duration: 1,
              ease: "power4.inOut",
              delay: 2,
              onComplete: function () {
                gsap.set(eval("jsLogo" + i), {
                  display: "none",
                });
              },
            });
          }

          tl.set(jsLogo, {
            width: "78.125%",
            x: "-50%",
            y: "50%",
            left: "50%",
            bottom: "50%",
            opacity: 0,
          })
            .to(jsLogo, {
              opacity: 1,
              duration: 1,
              ease: "power4.inOut",
              delay: 1,
            })
            .to(jsLogo, {
              // width: "79.296875%",
              width: "90.25%",
              duration: 1,
              ease: "power4.inOut",
              delay: 0,
            })
            .to(jsLogo, {
              duration: 1,
              y: "0",
              bottom: "5.402160864%",
              ease: "power4.inOut",
              delay: 1,
              onComplete: intro3,
            });
        } else {
          const prop_arry = [
            { w: 12.8990825688073, h: 19.3585858585859, x: 20.0825688073394, y: 0.0707070707070707 },
            { w: 13.6605504587156, h: 19.2424242424242, x: 40.8348623853211, y: 0.116161616161616 },
            { w: 21.4587155963303, h: 19.5252525252525, x: 60.5412844036697, y: -0.0202020202020202 },
            { w: 12.7155963302752, h: 19.7878787878788, x: -0.00458715596330275, y: 39.2929292929293 },
            { w: 12.2752293577982, h: 19.6010101010101, x: 20.7660550458716, y: 39.6767676767677 },
            { w: 15.6192660550459, h: 19.7878787878788, x: 40.848623853211, y: 39.2727272727273 },
            { w: 13.6330275229358, h: 19.3181818181818, x: 63.7018348623853, y: 39.459595959596 },
            { w: 12.6788990825688, h: 19.2777777777778, x: 87.2660550458716, y: 39.489898989899 },
            { w: 12.9082568807339, h: 19.3888888888889, x: 0.68348623853211, y: 79.4444444444445 },
            { w: 15.9220183486239, h: 20.0050505050505, x: 19.5963302752294, y: 79.9343434343434 },
            { w: 13.6422018348624, h: 19.3030303030303, x: 41.5596330275229, y: 80.3282828282828 },
            { w: 12.8394495412844, h: 19.8080808080808, x: 64.8623853211009, y: 80.0757575757576 },
            { w: 12.2018348623853, h: 19.6717171717172, x: 87.8119266055046, y: 80.3282828282828 },
          ];
          const prop2_arry = [
            { w: 8.05730659025788, h: 98.2820512820513, x: 8.53295128939828, y: 0 },
            { w: 8.53295128939828, h: 97.6923076923077, x: 44.4183381088825, y: 0 },
            { w: 13.4040114613181, h: 99.1282051282051, x: 79.6504297994269, y: 0 },
          ];
          let left_arr2 = [0, 47.7, 95.6];
          let tl = gsap.timeline();
          for (let i = 1; i <= 13; i++) {
            gsap.set(eval("jsLogo" + i), {
              left: prop_arry[i - 1].x + "%",
              top: prop_arry[i - 1].y + "%",
              width: prop_arry[i - 1].w + "%",
              height: "auto",
              opacity: 1,
            });
          }

          for (let i = 1; i <= 3; i++) {
            gsap.to(eval("jsLogo" + i), {
              left: prop2_arry[i - 1].x + "%",
              top: prop2_arry[i - 1].y + "%",
              width: prop2_arry[i - 1].w + "%",
              // height: prop2_arry[i - 1].h + "%",
              height: "auto",
              duration: 1,
              ease: "power4.inOut",
              delay: 3,
            });
          }
          for (let i = 4; i <= 13; i++) {
            gsap.to(eval("jsLogo" + i), {
              opacity: 0,
              duration: 1,
              ease: "power4.inOut",
              delay: 2,
              onComplete: function () {
                gsap.set(eval("jsLogo" + i), {
                  display: "none",
                });
              },
            });
          }
          tl.set(jsLogo, {
            width: "55.47073791%",
            x: "-50%",
            y: "50%",
            left: "50%",
            bottom: "50%",
            opacity: 0,
          })
            .to(jsLogo, {
              opacity: 1,
              duration: 1,
              ease: "power4.inOut",
              delay: 1,
            })
            .to(jsLogo, {
              width: "88.80407125%",
              // height: "4.577464789%",
              height: "39px",
              duration: 1,
              ease: "power4.inOut",
              delay: 1,
            })
            .to(jsLogo, {
              duration: 1,
              y: "0",
              bottom: "20px",
              ease: "power4.inOut",
              delay: 1,
              onComplete: intro3,
            });
        }
      }
    }
    function intro3() {
      console.log("intro3");
      jsNewsLetterModal.style.display = "block";
      if (jsNewsLetterModal) {
        const jsNewsLetterModalInner = document.querySelector(".js-news_letter-modal-inner");
        jsNewsLetterModal.addEventListener("click", (event) => {
          if (!jsNewsLetterModalInner.contains(event.target)) {
            jsNewsLetterModal.style.display = "none";
          }
        });
      }
    }
  } else {
    // console.log("intro none");
    jsLines.style.display = "none";
    jsLogo.style.display = "none";
    jsLogo_2.style.display = "block";
    jsMainLayout.style.display = "flex";
    jsMainLayout.style.opacity = "1";
  }

  if (jsMapBtn) {
    jsMapBtn.addEventListener("click", function (e) {
      console.log("jsMapBtn");
      this.classList.toggle("active");
      if (this.classList.contains("active")) {
        jsMainLayout.dataset.mode = "map";
        jsHeaderGrid.dataset.mode = "map";
      } else {
        jsMainLayout.dataset.mode = "";
        jsHeaderGrid.dataset.mode = "";
      }
    });
  }

  if (markers) {
    const w = 1304;
    const h = 823;
    let timer;
    let currentMarkerList = null;
    let marker = null;

    if (device === "pc") {
      markers.forEach((marker) => {
        marker.addEventListener("mouseover", function (e) {
          let cx = parseInt(this.getAttribute("cx"));
          let cy = parseInt(this.getAttribute("cy"));
          // let country = this.dataset.country;
          let country = this.getAttribute("id");

          clearTimeout(timer);
          timer = null;

          currentMarkerList = document.querySelector(".marker-list[data-country='" + country + "']");
          // console.log("marker:" + cx + "," + cy);

          markers.forEach((marker) => {
            marker.classList.remove("active");
          });
          marker = this;
          marker.classList.add("active");

          markerLists.forEach((ml) => {
            ml.style.display = "none";
          });

          currentMarkerList.style.display = "block";
          currentMarkerList.style.left = ((cx + 15) / w) * 100 + "%";
          currentMarkerList.style.top = ((cy - 15) / h) * 100 + "%";

          let rect = currentMarkerList.getBoundingClientRect();
          let viewerHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
          let diff = viewerHeight - rect.bottom;
          console.log(diff);

          if (diff < 0) {
            currentMarkerList.style.top = ((cy + diff - 10 - 15) / h) * 100 + "%";
          }

          currentMarkerList.addEventListener("mouseover", function (e) {
            marker.classList.add("active");
            this.style.display = "block";
            clearTimeout(timer);
            timer = null;
          });
          currentMarkerList.addEventListener("mouseout", function (e) {
            marker.classList.remove("active");
            this.style.display = "none";
            currentMarkerList = null;
          });

          // console.log(markerList + ":" + country);
        });
        marker.addEventListener("mouseout", function (e) {
          clearTimeout(timer);
          timer = null;

          timer = setTimeout(() => {
            marker.classList.remove("active");

            if (currentMarkerList) {
              currentMarkerList.style.display = "none";
              currentMarkerList = null;
            }
          }, 3000);
        });
      });
    } else {
      const map = document.querySelector(".rsr-map");

      markers.forEach((marker) => {
        marker.addEventListener("click", function (e) {
          // let country = this.dataset.country;
          let country = this.getAttribute("id");
          currentMarkerList = document.querySelector(".marker-list[data-country='" + country + "']");

          markers.forEach((marker) => {
            marker.classList.remove("active");
          });
          marker.classList.add("active");

          gsap.to(map, {
            uration: 1,
            scrollTo: { y: currentMarkerList, offsetY: 15 },
            ease: "power1.inOut",
          });
        });
      });
      if (jsMap) {
        jsMap.addEventListener("click", function (e) {
          markers.forEach((marker) => {
            marker.classList.remove("active");
          });
        });
      }
    }
  }

  if (jsMouseoverImgs) {
    // console.log("assetsPath:" + assetsPath);
    let modal;
    let overImg;
    jsMouseoverImgs.forEach((img) => {
      img.addEventListener("mouseover", function (e) {
        const src = this.dataset.imgNum && assetsPath + "over_img" + this.dataset.imgNum + ".svg";
        const num = parseInt(this.dataset.imgNum);
        if (src && num < 4) {
          // console.log("mouseover img:" + src);
          overImg = document.createElement("img");
          overImg.setAttribute("src", src);
          overImg.setAttribute("class", "rsr-over-img");
          document.body.appendChild(overImg);
        }
      });
      img.addEventListener("mouseout", function (e) {
        if (overImg) {
          document.body.removeChild(overImg);
          overImg = null;
        }
      });
    });
  }

  if (jsModalOpen) {
    let modalSwiper = null;
    let modalFigure = null;
    let timer;
    let swiper;
    let btn_flag = false;
    jsModalOpen.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        const type = this.dataset.modalType;
        console.log("jsModalOpen:" + type);
        if (type == "img") {
          modalFigure = document.createElement("figure");
          const img = this.cloneNode(true);
          img.removeAttribute("href");
          img.removeAttribute("target");
          img.removeAttribute("class");
          img.removeAttribute("data-modal-type");
          modalFigure.appendChild(img);
          modalFigure.setAttribute("class", "rsr-modal__figure");
          jsModal.appendChild(modalFigure);
        } else if (type == "slider") {
          const ul = this.closest(".rsr-gallery-list").cloneNode(true);
          ul.classList.add("swiper-wrapper");
          let a = ul.querySelectorAll("a");
          a.forEach((a) => {
            a.removeAttribute("href");
            a.removeAttribute("target");
            a.removeAttribute("class");
            a.removeAttribute("data-modal-type");
          });
          // console.log("slider:" + ul.innerHTML);
          swiper = document.createElement("div");
          swiper.setAttribute("class", "swiper rsr-swiper swiper1");
          swiper.appendChild(ul);
          jsModal.appendChild(swiper);

          // const swiperPagination = document.createElement("div");
          // swiperPagination.setAttribute("class", "swiper-pagination");
          // swiper.appendChild(swiperPagination);

          const swiperButtonNext = document.createElement("div");
          swiperButtonNext.setAttribute("class", "swiper-button-next");
          swiper.appendChild(swiperButtonNext);

          const swiperButtonPrev = document.createElement("div");
          swiperButtonPrev.setAttribute("class", "swiper-button-prev");
          swiper.appendChild(swiperButtonPrev);

          // document.addEventListener("click", function (event) {
          //   const clickedElement = event.target;
          //   const tagName = clickedElement.tagName.toLowerCase();
          //   const classList = clickedElement.classList;
          //   console.log(classList);
          //   if (!classList.contains("swiper-slide")) {
          //     console.log(tagName);
          //     modalClose();
          //   }
          // });

          if (modalSwiper) {
            modalSwiper.destroy();
            modalSwiper = null;
          }

          timer = null;
          clearTimeout(timer);

          timer = setTimeout(() => {
            modalSwiper = new Swiper(".rsr-swiper", {
              slidesPerView: 1,
              spaceBetween: 10,
              centeredSlides: true,
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            });
          }, 1);
        }

        gsap.fromTo(
          jsModal,
          { opacity: 0 },
          {
            opacity: 1,
            duration: 0.5,
            ease: "power4.inOut",
            onStart: function () {
              jsModal.style.display = "block";

              if (!btn_flag) {
                btn_flag = true;
                const jsModalBg = document.querySelector(".js-modal__bg");
                const jsModalBtn = document.querySelector(".js-modal__btn_close");

                const modalParts = [jsModalBg, jsModalBtn];
                modalParts.forEach((part) => {
                  // console.log("modal part:" + part);
                  if (part) {
                    part.addEventListener("click", function (e) {
                      modalClose();
                    });
                  }
                });
              }
            },
          }
        );
      });
    });

    function modalClose() {
      gsap.to(jsModal, {
        opacity: 0,
        duration: 0.5,
        ease: "power4.inOut",
        onComplete: function () {
          if (modalSwiper) {
            modalSwiper.destroy();
            modalSwiper = null;
            swiper.remove();
          }
          if (modalFigure) {
            modalFigure.remove();
            modalFigure = null;
          }
          jsModal.style.display = "none";
        },
      });
    }
  }

  if (jsProductsNavItems) {
    jsProductsNavItems.forEach((item) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        let num = parseInt(this.dataset.navNum);

        const rsrProductsCol = document.querySelector(".rsr-products-col");
        const rsrProductsCols = document.querySelector(".rsr-products-cols");

        // console.log("jsProductsNavItems:" + num + "," + rsrProductsCols.clientWidth);
        gsap.to(rsrProductsCols, {
          left: (num - 1) * 100 * -1 + "%",
          duration: 0.5,
          ease: "power4.inOut",
          onComplete: function () {},
        });
        jsProductsNavItems.forEach((item) => {
          item.classList.remove("current");
        });
        this.classList.add("current");
      });
    });
  }

  if (jsProductNames) {
    jsProductNamesInit();
  }

  function jsProductNamesInit() {
    // console.log("jsProductNames");
    let overImg;
    let cols = document.querySelectorAll(".rsr-products-col");
    function handleMouseMove(e) {
      if (overImg) {
        const x = e.clientX;
        const y = e.clientY;
        overImg.style.top = y + 10 + "px";
        overImg.style.left = x + 10 + "px";
        // console.log("mousemove");
      }
    }
    jsProductNames.forEach((name) => {
      let html = name.innerHTML;
      country_array.forEach((country) => {
        const regex = new RegExp(country, "g");
        html = html.replace(regex, `${country}<br />`);
      });
      name.innerHTML = html;
      // console.log("jsProductNames:" + html);

      name.addEventListener("mouseover", function (e) {
        let item = this.closest(".rsr-products-archive-list__item");
        let img = item.querySelector(".rsr-products-archive-list__media img");

        let bounds = item.getBoundingClientRect();

        let top = bounds.top + 25;
        let left = bounds.left + 45;
        const src = img.getAttribute("src");

        if (src) {
          // console.log("mouseover img:" + src);
          overImg = document.createElement("img");
          overImg.setAttribute("src", src);
          overImg.setAttribute("class", "rsr-over-product-img");
          overImg.style.top = top + "px";
          overImg.style.left = left + "px";
          overImg.style.width = item.clientWidth + "px";
          document.body.appendChild(overImg);

          name.addEventListener("mousemove", handleMouseMove);
        }
      });
      name.addEventListener("mouseleave", function (e) {
        name.removeEventListener("mousemove", handleMouseMove);
        if (overImg) {
          document.body.removeChild(overImg);
          overImg = null;
        }
      });

      // addEventListener("scroll", (event) => {});
    });
    cols.forEach((col) => {
      col.addEventListener("scroll", function (e) {
        if (overImg) {
          document.body.removeChild(overImg);
          overImg = null;
        }
      });
    });
  }

  if (device === "sp") {
    if (jsCols) {
      // console.log(jsCols);
      jsCols.forEach((col) => {
        col.addEventListener("click", function (e) {
          // const num = col.dataset.col;
          let num;
          col.classList.forEach((cl) => {
            if (cl.indexOf("rsr-main-") != -1) {
              num = cl.split("rsr-main-").join("");
            }
          });

          console.log(num);

          document.querySelector(".js-main-layout").classList.remove("menu1");
          document.querySelector(".js-main-layout").classList.remove("menu2");
          document.querySelector(".js-main-layout").classList.remove("menu3");
          document.querySelector(".js-main-layout").classList.remove("menu4");

          document.querySelector(".js-main-layout").classList.add("menu" + num);

          document.querySelector(".js-header-grid").classList.remove("menu1");
          document.querySelector(".js-header-grid").classList.remove("menu2");
          document.querySelector(".js-header-grid").classList.remove("menu3");
          document.querySelector(".js-header-grid").classList.remove("menu4");

          document.querySelector(".js-header-grid").classList.add("menu" + num);
        });
      });
    }
  } else {
    let overImg;
    jsColAbouts.forEach((col) => {
      col.addEventListener("mouseenter", function (e) {
        if (device === "pc") {
          const src = this.dataset.col && assetsPath + "over_img" + this.dataset.col + ".svg";
          const num = parseInt(this.dataset.col);
          if (src && num < 4) {
            console.log("mouseover img:" + src);
            overImg = document.createElement("img");
            overImg.setAttribute("src", src);
            overImg.setAttribute("class", "rsr-over-img");

            document.body.appendChild(overImg);
          }
        }
      });
      col.addEventListener("mouseleave", function (e) {
        if (device === "pc") {
          if (overImg) {
            document.body.removeChild(overImg);
            overImg = null;
          }
        }
      });
    });
  }
});

window.addEventListener("load", resize);
window.addEventListener("resize", resize);

function resize() {
  var viewerWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  var viewerHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  // console.log("viewerWidth:" + viewerWidth + ", viewerHeight:" + viewerHeight);

  const jsLayoutIinners = document.querySelectorAll(".js-layout-inner");
  const jsLayoutIinner3s = document.querySelectorAll(".js-layout-inner--3");

  jsLayoutIinners.forEach((inner) => {
    if (device === "sp") {
      if (!inner.classList.contains("js-nav-btn")) {
        if (inner.classList.contains("nopadding")) {
          inner.style.width = viewerWidth - 32 * 3 + "px";
        } else {
          inner.style.width = viewerWidth - 32 * 3 + "px";
        }
      }
    } else {
      if (inner.classList.contains("nopadding")) {
        inner.style.width = (viewerWidth - 38 * 2) / 4 + "px";
      } else {
        inner.style.width = (viewerWidth - 38 * 2) / 4 - 24 * 2 + "px";
      }
    }
  });

  if (jsLayoutIinner3s) {
    if (device === "sp") {
      jsLayoutIinner3s.forEach((inner) => {
        inner.style.width = viewerWidth - 32 + "px";
      });
    } else {
    }
  }
}
